module.exports = __webpack_public_path__ + "img/12cressge.9ad5fd3d.png";